import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Translation from '@wayfair/translation';
import Button from '../Button';
import DismissIcon from '@homebase/icons/dist/generated/DismissIcon';
import './CloseButton.$BRAND.css.js';

const CloseButton = ({variation, onClick, ...rest}) => {
  let label = rest.label;
  // if the label is not provided, fallback to a default translation
  // This preserves the previous `defaultProp` value, and ensures we only use Translations
  // within render (since it may access context in the future), additionally
  // we may want to consider enforcing that this prop is no longer optional
  // to push this translation into feature code rather than living within the component library
  if (label == null) {
    label = Translation({msgid: 'closeButton.close'});
  }

  return (
    <Button
      {...rest}
      variation={variation === 'inverted' ? 'veil' : 'primary'}
      hasIcon
      iconOnly
      isPlainText
      onClick={onClick}
      aria-label={label}
      data-hb-id="CloseButton"
    >
      <DismissIcon
        className={cx(
          'pl-CloseButton-icon',
          `pl-CloseButton-icon--${variation}`
        )}
      />
    </Button>
  );
};

CloseButton.propTypes = {
  // The variation to use:
  // - default - black icon
  // - primary - link colored icon
  // - inverted - white icon, for dark background
  variation: PropTypes.oneOf(['default', 'primary', 'inverted']),
  // Accessible label
  // eslint-disable-next-line react/require-default-props
  label: PropTypes.string,
  // Function called when the user activates the close button
  onClick: PropTypes.func.isRequired,
  // Optional Enzyme and Codeception testing identifiers
  testIds: PropTypes.shape({
    enzyme: PropTypes.string,
    codeception: PropTypes.string,
  }),
};

CloseButton.defaultProps = {
  variation: 'default',
};

export default CloseButton;
